'use strict';

var validatorModule = angular.module('validators', []);

validatorModule.directive('validator', function() {
  return {
    require: 'ngModel',
    scope: {
      validator: '=',
      validatorName: '=',
      required: '=',
    },
    link: function($scope, _el, _attr, ngModel) {

      function isValid(value) {
        if (value) {
          return $scope.validator(value);
        }
        if ($scope.required) {
          return false;
        }
        return true;
      }

      ngModel.$parsers.unshift(function(value) {
        var valid = isValid(value);
        ngModel.$setValidity($scope.validatorName, valid);
        return valid ? value : undefined;
      });

      ngModel.$formatters.unshift(function(value) {
        ngModel.$setValidity($scope.validatorName, isValid(value));
        return value;
      });

    },
  };
});
